
const taskQueuesByKey = {};

const getQueue = (key) => taskQueuesByKey[key] || Promise.resolve();

const enqueue = (queue, deferredTask, key) => {
  const executeTask = () => deferredTask();
  taskQueuesByKey[key] = queue.then(executeTask).catch(executeTask);
};

/**
 * A function used to queue similar tasks grouped by given key - tasks within a group are executed sequentially. Failing
 * tasks don't impact other tasks.
 *
 * @param deferredTask - a function returning Promise (in other words a task to be executed which returns Promise)
 * @param key - used to group tasks which should be executed sequentially
 * @return promise
 */
export function enqueueTaskByKey(deferredTask, key) {
  const queue = getQueue(key);
  enqueue(queue, deferredTask, key);
  return getQueue(key);
}
